import React, { Component } from 'react';
import {  Form, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import './Accent.css';

class Accent extends Component {
  constructor(props) {
    super(props);
    if (this.props.selected === "undefined") {
      this.props.selected = false;
    }

  }

  accentChanged = (e) => {
    this.props.accentChanged(e.target.value);
  }
  perRowAccentChanged = (e) => {
    this.props.perRowAccentChanged(e.target.value);
  }

  render() {
    return (
      <div className="accentSelect">

        <Form >
          <FormGroup>
          <FormControl type="select" style={{ padding: 0 }} onChange={this.accentChanged} componentClass="select" >
                <option value="">No Accent</option>
                {this.props.bricks.map(function (brick, index) {
                  return <option value={brick.id} key={index}>{brick.name}</option>
                }, this)}

              </FormControl>
          </FormGroup>
        </Form>
        <Form inline>
          <FormGroup >
              <ControlLabel htmlFor="defaultRows">every</ControlLabel>
              <FormControl type="number" id="defaultRows" value={this.props.accentEveryRow} onChange={this.perRowAccentChanged} style={{width:50}} />
              <ControlLabel htmlFor="defaultRows" >rows</ControlLabel>
          </FormGroup>
        </Form>
      </div>

    );
  }
}

export default Accent;
